import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 导购大使列表
 * @returns 
 */
export const fetchList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_SA_LIST, { params })
  return res.data.data ?? {};
}

/**
 * 确认入场
 * @returns 
 */
export const fetchCheckIn = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_SA_CHECKIN, { data })
  return res.data ?? {};
}

/**
 * 导购大使详情
 */
export const fetchSaInfo = async (service_id) => {
  const res = await GET(APIs.API_SERVICE_SAINFO, { params: { service_id } });

  return res.data.data ?? {};
};

/**
 * 编辑导购大使
 */
export const fetchEditSa = async (data) => {
  const res = await POST(APIs.API_SERVICE_EDITSA, { data });

  return res.data.data ?? {};
};
